import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import {
  getManageTranscriptionActionHandler,
  getMyDraftsActionHandler,
  getPublishedByMeActionHandler,
  getPublishedByOthersActionHandler,
} from "../../store/actions/actionHandlers/manageActionHandler";
import { manage } from "../../utils/mainTabs/manage/manage";
import { myDrafts } from "../../utils/mainTabs/manage/myDrafts";
import { tileSize } from "../../utils/tileSizes";
import { tileTypes } from "../../utils/tileTypes";
import { useDispatch, useSelector } from "react-redux";
import { publishedByMe } from "../../utils/mainTabs/manage/publishedByMe";
import { publishedByOthers } from "../../utils/mainTabs/manage/publishedByOthers";
import { manageTranscription } from "../../utils/mainTabs/manage/manageTranscription";
import { createTrainingType } from "../../utils/mainTabs/manage/createTrainingType";
import { createShotclasses } from "../../utils/mainTabs/manage/createShotclasses";
import { contentBulkUpload } from "../../utils/mainTabs/manage/contentBulkUpload";
import useFeatureChecks from "../../hooks/useFeatureChecks";
import { featureList } from "../../utils/featureList";
import { FiRefreshCw } from "react-icons/fi";
import {
  getManageTranscriptionAction,
  getMyDraftsAction,
  getPublishedByMeAction,
  getPublishedByOthersAction,
  //resetMyDraftsCountAction,
} from "../../store/actions/actionCreators/manageActionCreator";

const ManagePage = () => {
  const timerRef = useRef(180);
  const intervalRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const manageState = useSelector((state) => state.manageReducer);
  const { tenantName } = useOutletContext();
  const timerDisplayRef = useRef(null);
  const [refreshAPIS, setRefreshAPIS] = useState(false);

  const {
    myDraftsCount,
    publishedByMeCount,
    publishedByOthersCount,
    transcriptionDetailsCount,
  } = manageState;
  const { name, buttons, tiles, path } = manage;

  const managePath = path(tenantName);
  const myDraftsPath = myDrafts.path(tenantName);
  const publishedByMePath = publishedByMe.path(tenantName);
  const publishedByOthersPath = publishedByOthers.path(tenantName);
  const manageTranscriptionPath = manageTranscription.path(tenantName);
  const createTrainingTypePath = createTrainingType.path(tenantName);
  const contentBulkUploadPath = contentBulkUpload.path(tenantName);
  const edittranscribePath = createShotclasses.edittranscribepath(tenantName);

  const createShotclassesPath = createShotclasses.path(
    location,
    params,
    tenantName
  );
  const createShotclassesEditPath = createShotclasses.editpath(tenantName);
  const createShotclassesCopyPath = createShotclasses.copypath(tenantName);
  const createShotclassesViewPath = createShotclasses.viewpath(tenantName);

  const {
    // tiles: createShotclassTiles,
    navLinks: createShotclassNavLinks,
  } = createShotclasses;
  const { navLinks: createTrainingNavLinks } = createTrainingType;
  const { tiles: contentBulkUploadTiles, navLinks: contentBulkUploadNavLinks } =
    contentBulkUpload;

  const [manageHeader, setManageHeader] = useState("");
  const [manageNavLinks, setManageNavLinks] = useState([]);
  const [manageButtons, setManageButtons] = useState([]);
  const [manageTiles, setManageTiles] = useState([]);
  const [manageTilesType, setManageTilesType] = useState(
    tileTypes.DEFAULT_WITH_ICON
  );
  const [isManageStepTiles, setIsManageStepTiles] = useState(false);

  const { checkMSOMFeature } = useFeatureChecks();
  const menu = {
    roleMenu: "",
    MSOMMenu: featureList?.MANAGE_TRANSCRIPTION,
  };

  useEffect(() => {
    if (
      location.pathname === myDraftsPath ||
      location.pathname === publishedByMePath ||
      location.pathname === publishedByOthersPath ||
      location.pathname === manageTranscriptionPath
    ) {
      let tilesList = tiles(
        navigate,
        tenantName,
        myDraftsCount,
        publishedByMeCount,
        publishedByOthersCount,
        transcriptionDetailsCount
      );
      let buttonList = buttons(navigate, tenantName);
      if (!checkMSOMFeature(menu)) {
        const updatedTilesData = tilesList?.filter(
          (tile) => tile.label !== manageTranscription.label
        );
        setManageTiles(updatedTilesData);
      } else setManageTiles(tilesList);
      setManageTilesType(tileTypes.DEFAULT_WITH_ICON);
      setIsManageStepTiles(false);
      setManageButtons(buttonList);
      setManageNavLinks([]);
      setManageHeader(name);
    } else if (location.pathname === createTrainingTypePath) {
      let navLinksList = createTrainingNavLinks(navigate, tenantName);
      setManageTiles([]);
      setManageButtons([]);
      setManageNavLinks(navLinksList);
      setManageHeader("");
    } else if (location.pathname.includes(createShotclassesPath)) {
      if (!location.pathname.includes(edittranscribePath)) {
        setManageButtons([]);
      }
      let navLinksList = createShotclassNavLinks(
        navigate,
        location,
        tenantName
      );
      // let tilesList = createShotclassTiles(navigate);
      setManageTilesType(tileTypes.DEFAULT);
      setIsManageStepTiles(true);
      // setManageTiles(tilesList);
      setManageNavLinks(navLinksList);
      setManageHeader("");
    } else if (location.pathname.includes(contentBulkUploadPath)) {
      let navLinksList = contentBulkUploadNavLinks(navigate, tenantName);
      let tilesList = contentBulkUploadTiles(navigate, tenantName);
      setManageTilesType(tileTypes.SMALL);
      setIsManageStepTiles(false);
      setManageTiles(tilesList);
      setManageButtons([]);
      setManageNavLinks(navLinksList);
      setManageHeader("");
    }
  }, [
    tenantName,
    myDraftsPath,
    publishedByMePath,
    publishedByOthersPath,
    manageTranscriptionPath,
    contentBulkUploadPath,
    createTrainingTypePath,
    createShotclassesPath,
    edittranscribePath,
    location,
    params,
    name,
    buttons,
    tiles,
    navigate,
    myDraftsCount,
    publishedByMeCount,
    publishedByOthersCount,
    transcriptionDetailsCount,
    contentBulkUploadNavLinks,
    createShotclassNavLinks,
    createTrainingNavLinks,
    // createShotclassTiles,
    contentBulkUploadTiles,
  ]);

  useEffect(() => {
    if (location.pathname === managePath) {
      navigate(myDraftsPath);
    }
    if (
      myDraftsCount === null &&
      publishedByMeCount === null &&
      publishedByOthersCount === null &&
      transcriptionDetailsCount === null
    ) {
      if (location.pathname === myDraftsPath) {
        dispatch(
          getPublishedByMeActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getPublishedByOthersActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getManageTranscriptionActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      } else if (location.pathname === publishedByMePath) {
        dispatch(
          getMyDraftsActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getPublishedByOthersActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getManageTranscriptionActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      } else if (location.pathname === publishedByOthersPath) {
        dispatch(
          getMyDraftsActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getPublishedByMeActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getManageTranscriptionActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      } else if (location.pathname === manageTranscriptionPath) {
        dispatch(
          getMyDraftsActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getPublishedByMeActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
        dispatch(
          getPublishedByOthersActionHandler(
            "",
            1,
            1,
            () => {},
            () => {},
            () => {},
            true
          )
        );
      }
    }
  }, [
    myDraftsPath,
    publishedByMePath,
    publishedByOthersPath,
    manageTranscriptionPath,
    location,
    managePath,
    navigate,
    dispatch,
    myDraftsCount,
    publishedByMeCount,
    publishedByOthersCount,
    transcriptionDetailsCount,
  ]);

  useEffect(() => {
    dispatch(
      getPublishedByMeActionHandler(
        "",
        1,
        1,
        () => {},
        () => {},
        () => {},
        true
      )
    );
    dispatch(
      getPublishedByOthersActionHandler(
        "",
        1,
        1,
        () => {},
        () => {},
        () => {},
        true
      )
    );
    // dispatch(
    //   getManageTranscriptionActionHandler(
    //     "",
    //     1,
    //     1,
    //     () => {},
    //     () => {},
    //     () => {},
    //     true
    //   )
    // );
  }, []);

  const handleRefreshAPIs = useCallback(() => {
    setRefreshAPIS(true);
    dispatch(getPublishedByMeAction(null));
    dispatch(getMyDraftsAction(null));
    dispatch(getPublishedByOthersAction(null));
    dispatch(getManageTranscriptionAction(null));

    if (location.pathname === myDraftsPath) {
      dispatch(
        getPublishedByMeActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getPublishedByOthersActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getManageTranscriptionActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    } else if (location.pathname === publishedByMePath) {
      dispatch(
        getMyDraftsActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getPublishedByOthersActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getManageTranscriptionActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    } else if (location.pathname === publishedByOthersPath) {
      dispatch(
        getMyDraftsActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getPublishedByMeActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getManageTranscriptionActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    } else if (location.pathname === manageTranscriptionPath) {
      dispatch(
        getMyDraftsActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getPublishedByMeActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
      dispatch(
        getPublishedByOthersActionHandler(
          "",
          1,
          1,
          () => {},
          () => {},
          () => {},
          true
        )
      );
    }
  }, [
    dispatch,
    location.pathname,
    myDraftsPath,
    publishedByMePath,
    publishedByOthersPath,
    manageTranscriptionPath,
  ]);
  const startTimer = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      timerRef.current -= 1;
      if (timerDisplayRef.current) {
        timerDisplayRef.current.textContent = `${timerRef.current}`;
      }
      if (timerRef.current <= 0) {
        clearInterval(intervalRef.current);
        handleRefreshAPIs();
        timerRef.current = 180;
        if (timerDisplayRef.current) {
          timerDisplayRef.current.textContent = `${timerRef.current}`;
        }
        startTimer();
      }
    }, 1000);
  }, [handleRefreshAPIs]);

  useEffect(() => {
    if (
      location.pathname === myDraftsPath ||
      location.pathname === publishedByMePath ||
      location.pathname === publishedByOthersPath ||
      location.pathname === manageTranscriptionPath
    ) {
      startTimer();
    } else {
      timerRef.current = 180;
      if (timerDisplayRef.current) {
        timerDisplayRef.current.textContent = `${timerRef.current}`;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [
    location.pathname,
    myDraftsPath,
    publishedByMePath,
    publishedByOthersPath,
    manageTranscriptionPath,
    startTimer,
  ]);

  useEffect(() => {
    if (location.pathname === managePath) {
      navigate(myDraftsPath);
    }
    if (
      myDraftsCount === null &&
      publishedByMeCount === null &&
      publishedByOthersCount === null &&
      transcriptionDetailsCount === null
    ) {
      handleRefreshAPIs();
    }
  }, [
    location.pathname,
    managePath,
    myDraftsPath,
    myDraftsCount,
    publishedByMeCount,
    publishedByOthersCount,
    transcriptionDetailsCount,
    handleRefreshAPIs,
    navigate,
  ]);

  const handleRefreshIcon = () => {
    timerRef.current = 180;
    if (timerDisplayRef.current) {
      timerDisplayRef.current.textContent = `${timerRef.current}`;
    }
    handleRefreshAPIs();
    startTimer();
  };
  return (
    <>
      {(location.pathname === myDraftsPath ||
        location.pathname === publishedByMePath ||
        location.pathname === publishedByOthersPath ||
        location.pathname === manageTranscriptionPath) && (
        <div
          style={{
            fontSize: "1.6rem",
            textAlign: "right",
            padding: "2rem 2rem 0rem",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          Page will get refreshed in
          <span ref={timerDisplayRef}>{timerRef.current}</span> Seconds
          <div
            onClick={() => handleRefreshIcon()}
            style={{ cursor: "pointer", display: "flex" }}
          >
            <FiRefreshCw />
          </div>
        </div>
      )}
      <MainLayout
        heading={manageHeader}
        buttons={manageButtons}
        navLinks={manageNavLinks}
        tiles={manageTiles}
        tileType={manageTilesType}
        tileSize={tileSize.DEFAULT}
        isStepTile={isManageStepTiles}
      >
        <Outlet
          context={{
            manageTiles,
            tenantName,
            setManageTiles,
            setManageButtons,
            managePath,
            createShotclassesPath,
            edittranscribePath,
            createShotclassesEditPath,
            createShotclassesCopyPath,
            createShotclassesViewPath,
            refreshAPIS,
            setRefreshAPIS,
          }}
        />
      </MainLayout>
    </>
  );
};

export default ManagePage;
